import React, {forwardRef, useEffect, useState} from 'react';
import SmallSpinner from "../Spinners/SmallSpinner";

const APIImage = forwardRef((props, ref) => {
    const [error, setError] = useState(false)
    const [externalImage, setExternalImage] = useState(null)
    const [objectUrlImg, setObjectUrlImg] = useState(null)

    useEffect(() => {
        let url = new URL(props.src)
        url.searchParams.delete('access_token');
        url = url.toString()

        // Utilise les cookies HttpOnly pour l'authentification
        fetch(url, {credentials: 'include'})
            .then((response) => {
                if (response.ok) {
                    return response.blob();
                }
                setError(true)
                return undefined
            })
            .then(blob => {
                if (blob) {
                    setObjectUrlImg(window.URL.createObjectURL(blob))
                }
            })
    }, [props.src]);

    if (externalImage) {
        return <img {...props} />
    }

    if (error) {
        return <p>Erreur</p>
    }

    if (!objectUrlImg) {
        return <SmallSpinner {...props} />
    }

    const {src, ...otherProps} = props;

    return <img src={objectUrlImg} ref={(el) => {
        ref && ref(el)
    }} {...otherProps} />
})

export default APIImage;
